export const ExtractErrorMessage = (error: any): string => {
  // Handle axios error response
  if (error.response?.data) {
    return (
      error.response.data.error?.message ||
      error.response.data.message ||
      error.response.data.error ||
      JSON.stringify(error.response.data)
    );
  }

  // Handle direct error message
  if (error.message) {
    return error.message;
  }

  // Handle string errors
  if (typeof error === "string") {
    return error;
  }

  // Fallback
  return error.toString() || "";
};
